/* Copyright (c) 2024 Xperi. All Rights Reserved. */

/* eslint-disable no-shadow */
/* eslint-disable no-unused-vars */
export enum NdvrPlaybackType {
    RECORDING,
    CONTENT,
    UNIFIED_COLLECTION,
}
